import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2';
import directives from "./directives/"; 
import "@/styles/styles.scss";
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from './i18n';
import VCalendar from 'v-calendar';



const app = createApp(App);
directives(app);
app.use(i18n);
app.use(VueSweetalert2);
app.use(VCalendar, {})
app.use(router);
app.mount('#app');

